/* beautiful-react-hooks version: 0.31.1 */
import { typeof as _typeof } from '../_virtual/_rollupPluginBabelHelpers.js';

var isClient = (typeof window === "undefined" ? "undefined" : _typeof(window)) === 'object';

export default isClient;
